import { render, staticRenderFns } from "./TipImgPopup.vue?vue&type=template&id=46a29642&scoped=true&"
import script from "./TipImgPopup.vue?vue&type=script&lang=js&"
export * from "./TipImgPopup.vue?vue&type=script&lang=js&"
import style0 from "./TipImgPopup.vue?vue&type=style&index=0&id=46a29642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a29642",
  null
  
)

export default component.exports